import Link from "next/link";
import Image from "next/image";

const AmbitionsPro: React.FC = () => {
  return (
    <div className="grid gap-10 lg:grid-cols-2">
      <div className="flex flex-col items-start justify-center  md:pr-8 lg:max-w-lg xl:pr-0">
        <div className="mb-6 max-w-xl">
          <h2 className="max-w-lg text-whiteAccent sm:leading-none">
            Des ambitions <br /> professionelles
          </h2>
          <p>
            De la détection à l'apprentissage, en passant par l'accompagnement extra-esportif, nous permettons aux talents (joueurs et entraineurs)
            d'assimiler les exigences du plus haut niveau, de se professionnaliser, et d'exploiter leur potentiel.
          </p>
        </div>
        <div>
          <Link href="/leclub" passHref>
            <a
              aria-label="Aller sur la page du club"
              className="group inline-flex items-center text-xs font-semibold uppercase tracking-wider text-redAccent"
            >
              En savoir plus sur le club
              <svg
                className="ml-2 inline-block w-3 transform transition duration-500 ease-in-out group-hover:translate-x-1 group-focus:translate-x-1"
                fill="currentColor"
                viewBox="0 0 12 12"
              >
                <path d="M9.707,5.293l-5-5A1,1,0,0,0,3.293,1.707L7.586,6,3.293,10.293a1,1,0,1,0,1.414,1.414l5-5A1,1,0,0,0,9.707,5.293Z" />
              </svg>
            </a>
          </Link>
        </div>
      </div>
      <div className="-mx-4 flex items-center justify-center lg:pl-8">
        <div className="flex flex-col items-end px-3">
          <div className="group mb-6 h-28 w-28 transform overflow-hidden rounded object-cover shadow-lg transition-all duration-300 hover:scale-105 sm:h-48 sm:w-48 xl:h-56 xl:w-56">
            <Image
              placeholder="blur"
              blurDataURL={"/photos/Accueil/photo1.webp"}
              src="/photos/Accueil/photo1.webp"
              layout="fill"
              objectFit="cover"
              alt="Photo de LAN 1 (ApproX)"
            />
          </div>
          <div className="group h-20 w-20 transform overflow-hidden rounded object-cover shadow-lg transition-all duration-300 hover:scale-105 sm:h-32 sm:w-32 xl:h-40 xl:w-40">
            <Image
              src="/photos/Accueil/photo5.webp"
              placeholder="blur"
              blurDataURL={"/photos/Accueil/photo5.webp"}
              layout="fill"
              objectFit="cover"
              alt="Photo de LAN 2 (DraZ)"
            />
          </div>
        </div>
        <div className="px-3">
          <div className="group h-40 w-40 transform overflow-hidden rounded object-cover shadow-lg transition-all duration-300 hover:scale-105 sm:h-64 sm:w-64 xl:h-80 xl:w-80">
            <Image
              src="/photos/Accueil/photo3.webp"
              placeholder="blur"
              blurDataURL={"/photos/Accueil/photo3.webp"}
              layout="fill"
              objectFit="cover"
              alt="Photo du studio 6 Open Cup (DW vs BDS)"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AmbitionsPro;
